export const getEntryId = (_lastSegment) => {
    if( _lastSegment.split('_') ){
        return _lastSegment.split('_')[0];
    }
    return null;
}